import React from 'react'
import { Form, Select} from 'antd'
import { RESTRICTIONS_FIELD_NAME } from '../constants'
import { colors } from 'style/theme'
import { TooltipLabel } from 'components/TooltipLabel';

const { Option } = Select

let commonTagStyle = {
	height: 35,
	lineHeight: '33px',
	borderRadius: 5,
	borderColor: 'transparent',
	marginTop: 8,
	marginRight: 10,
	overflow: 'visible'
}

let commonTagButtonStyle = {
	height: 22,
	width: 22,
	borderRadius: '50%',
	top: '-8px',
	right: '-8px',
	color: '#fff',
	lineHeight: '22px'
}
let inclusiveRestrictionStyle = {
	tag: colors.success,
	button: { background: colors.success.color }
}

let exclusiveRestrictionStyle = {
	tag: colors.error,
	button: { background: colors.error.color }
}

let noMatchRestrictionStyle = {
	tag: colors.info,
	button: { background: colors.info.color }
}

// ToDo: remove this code once the issue is solved
// Warning horrible hack!
// https://github.com/ant-design/ant-design/issues/12910
const getRestrictionTag = (menuNode, props) => {
	let tagChildren = props.children.props.children.props.children[0].props.children[1].props.children
	if (tagChildren.length > 0) {
		for (let i = 0; i < tagChildren.length - 1; i++) {
			let title = props.children.props.children.props.children[0].props.children[1].props.children[i].props.title
			let styledTag = commonTagStyle
			let styledTagButton = commonTagButtonStyle
			if (title.includes('!')) {
				styledTag = { ...exclusiveRestrictionStyle.tag, ...styledTag }
				styledTagButton = { ...exclusiveRestrictionStyle.button, ...styledTagButton }
			} else {
				styledTag = { ...inclusiveRestrictionStyle.tag, ...styledTag }
				styledTagButton = { ...inclusiveRestrictionStyle.button, ...styledTagButton }
			}
			props.children.props.children.props.children[0].props.children[1].props.children[i] = React.cloneElement(
				props.children.props.children.props.children[0].props.children[1].props.children[i],
				{
					...props.children.props.children.props.children[0].props.children[1].props.children[i].props,
					style: {
						...props.children.props.children.props.children[0].props.children[1].props.children[i].props.style,
						...styledTag
					},
					children: [
						...props.children.props.children.props.children[0].props.children[1].props.children[i].props.children
					]
				}
			)
			props.children.props.children.props.children[0].props.children[1].props.children[
				i
			].props.children[1] = React.cloneElement(
				props.children.props.children.props.children[0].props.children[1].props.children[i].props.children[1],
				{
					style: styledTagButton
				}
			)
		}
	}
	return <div>{menuNode}</div>
}

const tooltipText = "Enter a pattern which will allow or disallow scanning on a certain URLs. i.e. http://mywebsite.com/blog will scan only pages under ‘blog’ folder. Use '!' to disallow specific URL or folder. i.e. !http://mywebsite.com/blog/2019 ";

const Restrictions = ({ getFieldDecorator, restrictions }) => {
	return (
		<Form.Item>
			 <TooltipLabel htmlFor="restrictions" value="RESTRICTIONS" tooltip={{text: tooltipText}} />
			{getFieldDecorator(RESTRICTIONS_FIELD_NAME, {
				validateTrigger: ['onChange', 'onBlur']
			})(
				<Select id="restrictions" size="large" mode="tags" dropdownRender={getRestrictionTag}>
					{restrictions.map((r, i) => (
						<Option key={r.id || i} value={r.restriction || r}>
							{r.restriction || r}
						</Option>
					))}
				</Select>
			)}
		</Form.Item>
	)
}
export default Restrictions
